import { Injectable, ComponentRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PopoverComponent } from '../components/popover/popover.component';

@Injectable()
export class PopoversService {

    private openPopover: ComponentRef<PopoverComponent>;
    private openPopoverProvider: BehaviorSubject<ComponentRef<PopoverComponent>>;

    constructor() {
        this.createProviders();
    }

    /**
    * Gets the popover
    */
    public getOpenPopover(): Observable<ComponentRef<PopoverComponent>> {
        return this.openPopoverProvider;
    }

    /**
    * Sets the popover
    */
    public setOpenPopover(popover: ComponentRef<PopoverComponent>) {
        this.openPopover = popover;
        this.openPopoverProvider.next(popover);
    }

    /**
    * Creates the providers this service relies on
    */
    private createProviders(): void {
        this.openPopover = null;
        this.openPopoverProvider = new BehaviorSubject<ComponentRef<PopoverComponent>>(null);
    }

}
